/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Verdict } from './Verdict';
import {
    VerdictFromJSON,
    VerdictFromJSONTyped,
    VerdictToJSON,
    VerdictToJSONTyped,
} from './Verdict';

/**
 * 
 * @export
 * @interface SubmissionFeedback
 */
export interface SubmissionFeedback {
    /**
     * 
     */
    kind: SubmissionFeedbackKindEnum;
    /**
     * 
     */
    text: string;
    /**
     * 
     */
    verdict: Verdict | null;
    /**
     * 
     */
    lengthMm: number | null;
    /**
     * 
     */
    girthMm: number | null;
    /**
     * 
     */
    weightG: number | null;
    /**
     * 
     */
    species: string | null;
    /**
     * 
     */
    speciesScientific: string | null;
    /**
     * 
     */
    lengthDeltaPct: number | null;
}


/**
 * @export
 */
export const SubmissionFeedbackKindEnum = {
    Measurement: 'measurement',
    Confirmed: 'confirmed',
    Agreed: 'agreed',
    Disagreed: 'disagreed',
    NotFish: 'not_fish',
    Chatter: 'chatter',
    Unresolved: 'unresolved',
    Unreadable: 'unreadable',
} as const;
export type SubmissionFeedbackKindEnum = typeof SubmissionFeedbackKindEnum[keyof typeof SubmissionFeedbackKindEnum];


/**
 * Check if a given object implements the SubmissionFeedback interface.
 */
export function instanceOfSubmissionFeedback(value: object): value is SubmissionFeedback {
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('verdict' in value) || value['verdict'] === undefined) return false;
    if ((!('lengthMm' in (value as Record<string, any>)) && !('length_mm' in (value as Record<string, any>))) || ((value as Record<string, any>)['lengthMm'] === undefined && (value as Record<string, any>)['length_mm'] === undefined)) return false;
    if ((!('girthMm' in (value as Record<string, any>)) && !('girth_mm' in (value as Record<string, any>))) || ((value as Record<string, any>)['girthMm'] === undefined && (value as Record<string, any>)['girth_mm'] === undefined)) return false;
    if ((!('weightG' in (value as Record<string, any>)) && !('weight_g' in (value as Record<string, any>))) || ((value as Record<string, any>)['weightG'] === undefined && (value as Record<string, any>)['weight_g'] === undefined)) return false;
    if (!('species' in value) || value['species'] === undefined) return false;
    if ((!('speciesScientific' in (value as Record<string, any>)) && !('species_scientific' in (value as Record<string, any>))) || ((value as Record<string, any>)['speciesScientific'] === undefined && (value as Record<string, any>)['species_scientific'] === undefined)) return false;
    if ((!('lengthDeltaPct' in (value as Record<string, any>)) && !('length_delta_pct' in (value as Record<string, any>))) || ((value as Record<string, any>)['lengthDeltaPct'] === undefined && (value as Record<string, any>)['length_delta_pct'] === undefined)) return false;
    return true;
}

export function SubmissionFeedbackFromJSON(json: any): SubmissionFeedback {
    return SubmissionFeedbackFromJSONTyped(json, false);
}

export function SubmissionFeedbackFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionFeedback {
    if (json == null) {
        return json;
    }
    return {
        
        'kind': json['kind'],
        'text': json['text'],
        'verdict': VerdictFromJSON(json['verdict']),
        'lengthMm': json['length_mm'],
        'girthMm': json['girth_mm'],
        'weightG': json['weight_g'],
        'species': json['species'],
        'speciesScientific': json['species_scientific'],
        'lengthDeltaPct': json['length_delta_pct'],
    };
}

export function SubmissionFeedbackToJSON(json: any): SubmissionFeedback {
    return SubmissionFeedbackToJSONTyped(json, false);
}

export function SubmissionFeedbackToJSONTyped(value?: SubmissionFeedback | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'kind': value['kind'],
        'text': value['text'],
        'verdict': VerdictToJSON(value['verdict']),
        'length_mm': value['lengthMm'],
        'girth_mm': value['girthMm'],
        'weight_g': value['weightG'],
        'species': value['species'],
        'species_scientific': value['speciesScientific'],
        'length_delta_pct': value['lengthDeltaPct'],
    };
}

